import React, { useState } from 'react';

import { navigate, Link } from '@reach/router';
import { Auth } from 'aws-amplify';
import { setUser, isLoggedIn } from '../../utils/auth';
import Error from '../Error';

import logo from '../../assets/images/fentySkin.svg';

import { Button, Logo } from '../../styles/style';

// import StyledButton from '../StyledComponents/StyledButton';
import StyledInput from '../StyledComponents/StyledInput';
import StyledForm from '../StyledComponents/StyledForm';
import FieldList from '../StyledComponents/FieldList';
import { Container, Wrapper, ButtonWrapper } from './styles';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showVideo, setShowVideo] = useState(false);

  const handleLogin = async () => {
    try {
      await Auth.signIn(username, password);
      const user = await Auth.currentAuthenticatedUser();
      const userInfo = {
        ...user.attributes,
        username: user.username,
      };
      setUser(userInfo);
      navigate('/app');
    } catch (err) {
      setError(err);
    }
  };

  if (isLoggedIn()) navigate('/app');
  return (
    <Container>
      <Wrapper className="pinkWrapper">
        <Logo mask={logo} />
        {!showVideo ? (
          <>
            <h2 className="emphasis">GET INTO THE NEW CULTURE OF SKINCARE</h2>
            <h2>WELCOME TO THE FENTY SKINCARE LAUNCH</h2>
            <h2>ISSA HOUSE PARTY!</h2>
            <StyledForm onSubmit={handleLogin}>
              <FieldList>
                <li>
                  <label htmlFor="username">Username</label>
                  <StyledInput
                    onChange={(e) => {
                      setUsername(e.target.value);
                    }}
                    required
                    placeholder="Username"
                    name="username"
                    id="username"
                    value={username}
                  />
                </li>
                <li>
                  <label htmlFor="username">Password</label>
                  <StyledInput
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    placeholder="Password"
                    name="password"
                    id="password"
                    required
                    value={password}
                    type="password"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        e.stopPropagation();
                        handleLogin();
                      }
                    }}
                  />
                </li>
              </FieldList>

              <ButtonWrapper>
                <Button role="button" onClick={handleLogin} className="button">
                  <span>Login</span>
                </Button>
                <br />
                <Link className="crossLink" to="/app/signup">
                  I need to register
                </Link>
              </ButtonWrapper>

              {error && <Error errorMessage={error} />}
            </StyledForm>

            <button
              style={{
                background: 'red',
                border: 0,
                textAlign: 'center',
                cursor: 'pointer',
                width: '100%',
                marginTop: '10px',
                padding: '10px 0',
              }}
              onClick={() => setShowVideo(true)}
              type="button"
            >
              this event is complete, click here for a video of the experience
            </button>
          </>
        ) : (
          <>
            <video style={{ width: '100%' }} controls>
              <source
                src="/assets/videos/fentyskin_launchparty_recap.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <button
              style={{
                background: 'none',
                border: 0,
                textAlign: 'center',
                cursor: 'pointer',
                width: '100%',
                marginTop: '10px',
                padding: '10px 0',
              }}
              onClick={() => setShowVideo(false)}
              type="button"
            >
              back to login
            </button>
          </>
        )}
      </Wrapper>
    </Container>
  );
};

export default Login;
